import NextLink, { LinkProps } from "next/link";
import { AnchorHTMLAttributes, FC } from "react";

const Link: FC<LinkProps & AnchorHTMLAttributes<HTMLAnchorElement>> = (
  props
) => {
  const { children } = props;
  return (
    <NextLink {...props} prefetch={false} legacyBehavior>
      {children}
    </NextLink>
  );
};

export default Link;
